import { Button, Container, Stack } from "@mui/material";
import TitleHeader from "components/TitleHeader";
import { addDays } from "date-fns";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { setHeaderDetails } from "store/actions/header";
import {
  getCurrentNutrition,
  getInitialNutrition,
  setNutritionData,
  setTotalWeekNutrition,
} from "store/actions/nutritions";
import { setPrompt } from "store/actions/prompt";
import { ATTENTION_MESSAGE } from "utils/constants";
import Loader from "../../components/Loader";
import NutritionDetails from "./NutritionDetails";

const CreateNutritionPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const { type } = useSelector((state) => state.user.userDetails);
  const isAdmin = type?.toUpperCase() === "ADMIN";

  const nutritionData = useSelector((state) => state.nutritions.nutritionData);
  const isEvocoachTemplate = nutritionData?.coach_id === "evocoach";
  const isLoadingNutritins = useSelector(
    (state) => state.nutritions.isLoadingNutritins
  );
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [isPageReady, setIsPageReady] = useState(!id);

  const [editorValue, setEditorValue] = useState("<p></p>");
  const [savedEditorValue, setSavedEditorValue] = useState("<p></p>");
  useEffect(() => {
    if (nutritionData) {
      setSavedEditorValue(nutritionData.description);
    }
  }, [nutritionData]);

  useEffect(() => {
    if (id && _.isEmpty(location.state)) {
      dispatch(getCurrentNutrition(id)).then(() => setIsPageReady(true));
    } else if (id) {
      setIsPageReady(true);
    } else {
      const today = new Date().toISOString().split('T')[0];
      dispatch(setNutritionData({ ...nutritionData, start_date: today }));
    }
    const navDetail = {
      isBreadcrumns: true,
      title: "",
      breadcrumsList: [
        {
          title: "Programmes de nutrition",
          link: "/nutrition/programs",
          command: () => {
            dispatch(
              setPrompt({
                isOpen: true,
                message: ATTENTION_MESSAGE,
                primaryBtnHandler: () => {
                  navigate("/nutrition/programs");
                },
                btnAlign: "right",
                primaryBtnColor: "error",
                secondaryBtnText: "Annuler",
              })
            );
          },
        },
        {
          title: "Étape 1",
          link: "",
        },
      ],
    };
    dispatch(setHeaderDetails(navDetail));
  }, []);

  if (isLoadingNutritins) {
    return <Loader isLoading={isLoadingNutritins} />;
  }
  const handleFormSubmit = () => {
    if (nutritionData?.status === "Modèle" && !isAdmin) {
      navigate(`/nutrition/programs/final${id ? `/${id}` : ""}`);
    } else {
      formRef.current?.handleSubmit();
    }
  };
  return (
    <>
      <Container
        maxWidth="xxl"
        className="header-box"
        sx={{ padding: "0 !important", marginBottom: "20px" }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems="center"
          justifyContent="space-between"
          gap={1}
        >
          <TitleHeader title={isAdmin ? "Créer un template" : "Créer un nouveau programme"} />
          {isPageReady && (
            isEvocoachTemplate && !isAdmin ? (
              <Button
                color="primary"
                variant="contained"
                onClick={() => navigate(`/nutrition/programs/final${id ? `/${id}` : ""}`)}
              >
                Voir le programme
              </Button>
            ) : (
              <Button
                type="submit"
                color="success"
                variant="contained"
                onClick={() => handleFormSubmit()}
                disabled={formRef.current?.isSubmitting}
              >
                Continuer
              </Button>
            )
          )}
        </Stack>
      </Container>
      <Container className="detail" maxWidth="xxl">
        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          initialValues={nutritionData}
          onSubmit={(values) => {
            const startDate = values.start_date || new Date().toISOString().split('T')[0];
            const data = {
              ...values,
              start_date: startDate,
              description: editorValue,
              end_date: dayjs(
                addDays(new Date(startDate), values?.program_weeks * 7)
              ),
            };
            setIsFormDirty(false);
            dispatch(setTotalWeekNutrition(values.program_weeks));
            dispatch(getInitialNutrition(values.program_weeks));
            dispatch(setNutritionData(data));
            setTimeout(() => {
              navigate(`/nutrition/programs/final${id ? `/${id}` : ""}`);
            }, 500);
          }}
        >
          {(props) => {
            const { dirty } = props;
            setIsFormDirty(dirty);
            return (
              <Form>
                <NutritionDetails
                  editorValue={editorValue}
                  setEditorValue={setEditorValue}
                  savedEditorValue={savedEditorValue}
                />
              </Form>
            );
          }}
        </Formik>
      </Container>
    </>
  );
};

export default CreateNutritionPage;
